import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5 9.166-1.413 1.06c-.704.528-1.056.792-1.31 1.127a3 3 0 0 0-.495.99c-.115.403-.115.843-.115 1.723v2.6L5 15.833m10-6.667 1.413 1.06c.704.528 1.056.792 1.31 1.127.225.296.393.632.495.99.115.403.115.843.115 1.723v2.6L15 15.833m-5 2.5v-2.5m1.667-6.666a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0ZM6.93 3.675v0c-.637.59-.955.885-1.197 1.226a4 4 0 0 0-.647 1.482C5 6.793 5 7.226 5 8.095v5.238c0 .93 0 1.394.077 1.78a4 4 0 0 0 3.143 3.143c.386.077.85.077 1.78.077v0c.93 0 1.394 0 1.78-.076a4 4 0 0 0 3.143-3.143c.077-.387.077-.851.077-1.78v-5.24c0-.868 0-1.302-.086-1.71a4.001 4.001 0 0 0-.648-1.483c-.241-.341-.56-.636-1.197-1.226v0c-.968-.896-1.452-1.344-1.986-1.551a3 3 0 0 0-2.165 0c-.535.207-1.02.655-1.987 1.551Z"
    />
  </svg>
)
export default SvgComponent
